/**
 * SWR options for GET /stripe/customer.
 *
 * A null body means the user has no Stripe customer yet (new buyer). That is
 * not a retryable failure — retries and focus revalidation caused checkout to
 * stay gated on "Loading card form…".
 */
export const stripeCustomerSwrOptions = {
	errorRetryCount: 0,
	revalidateOnFocus: false,
} as const;
